import { root } from './new-viewers';

export const newViewers = {
  ...root,
};
